import { useTranslation } from 'react-i18next'
import React from 'react'

import { usePlaceType } from '../../_context/PlaceTypeContext'
import MPageHeader from '../../../../components/presentation/M.PageHeader'
import PlacesControlBar from './PlacesControlBar'
import PlacesCounterBar from './PlacesCounterBar'

const MPlacesListPage = () => {
  const type = usePlaceType()
  const { t } = useTranslation(['common', 'listPlaces'])
  const title = type === 'location' ? t(`listPlaces:title`) : t(`listPlaces:title`, { context: type })
  return (
    <>
      <MPageHeader title={title} />
      <PlacesControlBar />
      <PlacesCounterBar />
    </>
  )
}

export default MPlacesListPage
